// Polyfill
import "intersection-observer";
import objectFitImages from "object-fit-images";
import closetPolyfill from "./lib/closet.polyfill";
objectFitImages();
closetPolyfill();

// Librally
// ---------------------------------------
// import Swiper, { Autoplay, Navigation } from 'swiper';
// import 'swiper/css';
// Swiper.use([Navigation,Autoplay]);

import Toggle from "./lib/Toggle";

// import "./lib/smoothScroll";
import "./lib/accordion";
import { TocNav } from "./lib/toc";
import smoothScroll from "./lib/smoothScroll";
import { webinarSlider } from "./lib/webinarSlider";

TocNav();
webinarSlider();

(() => {
  /**
   * Toggle Menu
   */
  const globalToggle = new Toggle(".js-button-hamburger");
})();
